// Registers the PWA service worker (production only, since CRA dev server hot-reload
// conflicts with SW caching). Dispatches a window event when an install prompt is
// available so the UI can show an "Install App" button.

let deferredInstallPrompt = null;

export function registerPWA() {
  if (!("serviceWorker" in navigator)) return;

  // We register in both dev and prod so the user can install directly from the
  // preview URL. The SW uses stale-while-revalidate so HMR / live reload still
  // works (network is hit first; cache is the fallback).

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/sw.js`;
    navigator.serviceWorker
      .register(swUrl)
      .then((reg) => {
        // eslint-disable-next-line no-console
        console.log("[PWA] Service worker registered:", reg.scope);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[PWA] SW registration failed:", err);
      });
  });
}

// Capture the browser's beforeinstallprompt event so we can trigger it later.
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredInstallPrompt = e;
    window.dispatchEvent(new CustomEvent("pwa:installable"));
  });

  window.addEventListener("appinstalled", () => {
    deferredInstallPrompt = null;
    window.dispatchEvent(new CustomEvent("pwa:installed"));
  });
}

export async function triggerInstallPrompt() {
  if (!deferredInstallPrompt) return { outcome: "unavailable" };
  deferredInstallPrompt.prompt();
  const choice = await deferredInstallPrompt.userChoice;
  deferredInstallPrompt = null;
  return choice;
}

export function isInstallPromptAvailable() {
  return !!deferredInstallPrompt;
}

export function isStandaloneMode() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator?.standalone === true
  );
}
